import { Routes, Route } from 'react-router-dom';
import WorkOrders from '../child_components/WorkOrders';
import CustomerList from '../child_components/CustomerList';
import Fleet from './Fleet';

function Customer() {
    return (
        <div>
            <Routes>
                <Route path='/work_orders' element={<WorkOrders />} />
                <Route path='/individual' element={<CustomerList />} />
                <Route path='/fleet' element={<Fleet />} />
            </Routes>
        </div>
    )
}

export default Customer;